import React from "react";
import { ClipboardList, MessageSquare, Receipt, Wrench } from "lucide-react";

export const STEPS = [
  {
    icon: MessageSquare,
    title: "Tell us about your vehicle",
    body: "Share your make, model, year and how you use it.",
  },
  {
    icon: ClipboardList,
    title: "We recommend the right setup",
    body: "We confirm fitment and suggest the best options.",
  },
  {
    icon: Receipt,
    title: "Approve the quote",
    body: "A clear quote covering supply and installation.",
  },
  {
    icon: Wrench,
    title: "Workshop installation",
    body: "Fitted by our team and ready for the road.",
  },
];

/** Compact vertical/grid version for the sidebar. */
export function ProcessRail() {
  return (
    <div className="card-nq p-4" data-testid="process-rail">
      <p className="text-[10px] font-semibold uppercase tracking-[0.16em] green-text">
        From enquiry to installation
      </p>
      <div className="mt-4 grid grid-cols-4 gap-2">
        {STEPS.map((s, i) => (
          <div key={s.title} className="text-center" data-testid="process-rail-step">
            <s.icon className="mx-auto h-5 w-5 green-text" />
            <p className="mt-2 font-mono text-xs font-semibold text-[color:var(--nq-sand)]">{i + 1}</p>
            <p className="mt-1 text-[10px] font-semibold leading-tight text-[color:var(--nq-sand)]">
              {s.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

/** Full-width numbered strip for the bottom of the page. */
export default function ProcessSteps() {
  return (
    <section
      className="rounded-xl border p-6 md:p-8"
      style={{ borderColor: "rgba(255,255,255,0.09)", background: "var(--nq-ink)" }}
      data-testid="process-steps"
    >
      <h2 className="text-center text-sm font-bold uppercase tracking-[0.16em] text-[color:var(--nq-sand)]">
        The NQ Springs installation process
      </h2>
      <div className="mt-7 grid gap-6 md:grid-cols-4">
        {STEPS.map((s, i) => (
          <div key={s.title} className="relative" data-testid="process-step">
            <span
              className="flex h-10 w-10 items-center justify-center rounded-full border font-mono text-sm font-semibold green-text"
              style={{ borderColor: "rgba(198,162,74,0.4)" }}
            >
              {i + 1}
            </span>
            <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.12em] green-text">
              {s.title}
            </p>
            <p className="mt-1.5 text-sm leading-relaxed text-[color:var(--nq-stone)]">{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
